import html2canvas from 'html2canvas';
import React, {useContext, useState} from 'react';
import {useAlert} from 'react-alert';
import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {Document, Page, pdfjs} from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Api from '../Api';
import {authContext} from '../auth/AuthContext';
import Helper from '../auth/Helper';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
	pdfjs.version
}/pdf.worker.js`;

const Sidebar_inner = (props) => {
	const alert = useAlert();
	const [renderPdf, setrenderPdf] = useState('');
	const options = {
		cMapUrl: 'cmaps/',
		cMapPacked: true
	};

	const {auth} = useContext(authContext);

	let userId = 0;
	let userImg = 0;
	let userName = '';
	if (auth.data) {
		userId = auth.data.id;
		userImg = auth.data.img;
		userName = auth.data.name;
	}

	const [toggleMenuData, settoggleMenuData] = useState(0);
	const activeMenuData = window.location.pathname;
	const [file, setFile] = useState('');
	const [numPages, setNumPages] = useState(null);

	function logout() {
		localStorage.removeItem('plan_className_id');
		alert.show('Log out Successfully', {
			timeout: 2000, // custom timeout just for this one alert
			type: 'success', // callback that will be executed after this alert open
			/*onOpen: () => {
			  
			}, */ onClose: () => {
				localStorage.clear();
				window.location.href = '/';
			}
		});
	}

	const logo = {
		width: '155px'
	};

	function onDocumentLoadSuccess({numPages: nextNumPages}) {
		setNumPages(nextNumPages);
	}
	function onDocument2Canvas() {
		const input = document.getElementById('divToPrint');
		const canvas = html2canvas(input).then((canvas) => {
			var link = document.createElement('a');
			link.setAttribute('download', 'Certificate.png');
			link.setAttribute(
				'href',
				canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
			);
			link.click();
		});
	}
	const downloadDemoCertificate = () => {
		Helper.getAtuhData().then((result) => {
			var obj = {
				name: result.name,
				last_name: result.last_name
			};
			console.log(obj);
			Api.downloadDemoCertificate(obj).then((response) => {
				console.log(response.data.file);
				// let file = "http://localhost:3000/uploads/"+response.data.file;
				const file_new = response.data.file;
				//console.log(file_new);

				confirmAlert({
					customUI: ({onClose}) => {
						return (
							<div class="take_modal">
								<div class="take_modal_inner">
									<div class="take_modal_header">
										<h5 class="take_modaltitle" id="pdfViewer">
											Certificate Preview
										</h5>
										<button
											onClick={() => {
												onClose();
											}}
											type="button"
											class="close"
											data-dismiss="modal"
											aria-label="Close">
											<span aria-hidden="true">&times;</span>
										</button>
									</div>
									<div class="take_modal_body">
										<div class="take_step_wrapper">
											<div
												className="Example__container__document"
												id="divToPrint">
												<Document
													URL="https://take5music.in/take5app1/studentApi/uploads/haresh_testing.pdf"
													onLoadSuccess={onDocumentLoadSuccess}
													options={options}
													id="divToPrint">
													<Page pageNumber={1} />
												</Document>
											</div>

											<div class="take_step_btns">
												<a
													onClick={(e) => {
														onDocument2Canvas(file_new);
													}}
													class="take_btn take_next">
													Print
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					}
				});
			});
		});
	};

	return (
		<div class="take_sidebar_wrapper">
			<div class="take_logo">
				<a href="/">
					<picture>
						<source
							media="(max-width:991px)"
							srcset="assets/images/logo_icon.png"
						/>
						<img src="assets/images/logonew.png" class="img-fluid" alt="" />
					</picture>
				</a>
			</div>

			<div class="take_menu">
				<ul>
					<li>
						<a
							className={activeMenuData == '/student-dashboard' && 'active'}
							href="/student-dashboard-0">
							<svg
								width="28"
								height="25"
								viewBox="0 0 28 25"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M14.6745 0.365677C14.2924 0.0169974 13.7076 0.0171651 13.3258 0.366064L0.323516 12.2473C-0.077346 12.6136 -0.101015 13.237 0.27092 13.6327C0.635604 14.0206 1.24429 14.0436 1.63717 13.6842L2.22425 13.1473V22.007C2.22425 23.2458 3.22847 24.25 4.46724 24.25H23.5326C24.7714 24.25 25.7756 23.2458 25.7756 22.007V13.1473L26.3626 13.6841C26.7555 14.0435 27.3643 14.0205 27.729 13.6326C28.101 13.2369 28.0774 12.6135 27.6766 12.2472L21.8504 6.92038V2.04463C21.8504 1.50267 21.411 1.06332 20.8691 1.06332C20.3271 1.06332 19.8878 1.50267 19.8878 2.04463V5.12401L14.6745 0.365677ZM13.3248 2.99467C13.7069 2.64489 14.293 2.64488 14.6751 2.99467L23.813 11.3585V22.3179H17.9252V13.6567C17.9252 13.1044 17.4775 12.6567 16.9252 12.6567H11.0747C10.5224 12.6567 10.0747 13.1044 10.0747 13.6567V22.3179H4.18688V11.3585L13.3248 2.99467ZM12.0373 14.589H15.9626V22.3178H12.0373V14.589Z"
								/>
							</svg>
							<span>home</span>
						</a>
					</li>
					<li>
						<a
							className={activeMenuData == '/course-schedule' && 'active'}
							href="course-schedule">
							<svg
								width="28"
								height="28"
								viewBox="0 0 28 28"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M24 0.875C21.7909 0.875 20 2.66586 20 4.87501V23.125C20 25.3341 21.7909 27.125 24 27.125C26.2091 27.125 28 25.3341 28 23.125V4.87501C28 2.66586 26.2091 0.875 24 0.875ZM22 4.89422C22 3.78966 22.8954 2.89423 24 2.89423C25.1046 2.89423 26 3.78966 26 4.89422V23.1058C26 24.2103 25.1046 25.1058 24 25.1058C22.8954 25.1058 22 24.2103 22 23.1058V4.89422ZM4 6.93271C1.79086 6.93271 0 8.72357 0 10.9327V23.125C0 25.3342 1.79086 27.125 4 27.125C6.20914 27.125 8 25.3342 8 23.125V10.9327C8 8.72357 6.20914 6.93271 4 6.93271ZM2.00001 10.9519C2.00001 9.84737 2.89544 8.95194 4.00001 8.95194C5.10457 8.95194 6 9.84737 6 10.9519V23.1058C6 24.2104 5.10457 25.1058 4.00001 25.1058C2.89544 25.1058 2.00001 24.2104 2.00001 23.1058V10.9519ZM14 12.9904C11.7909 12.9904 10 14.7812 10 16.9904V23.125C10 25.3341 11.7909 27.125 14 27.125C16.2091 27.125 18 25.3341 18 23.125V16.9904C18 14.7813 16.2091 12.9904 14 12.9904ZM12 17.0096C12 15.905 12.8954 15.0096 14 15.0096C15.1046 15.0096 16 15.9051 16 17.0096V23.1058C16 24.2103 15.1046 25.1058 14 25.1058C12.8954 25.1058 12 24.2103 12 23.1058V17.0096Z"
								/>
							</svg>
							<span>Course Schedule</span>
						</a>
					</li>
					{/*  <li>
                            <a href="dashboard.html">
                               <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6498 0C11.7747 0 11.0236 0.623124 10.862 1.4832V1.4832C10.7358 2.15515 10.2388 2.68868 9.60339 2.94112C8.52067 3.37127 7.52003 3.95124 6.62266 4.65983C6.08568 5.08385 5.37486 5.24831 4.72911 5.02219V5.02219C3.90294 4.73291 2.98784 5.07236 2.55021 5.83045L1.19238 8.18254C0.759228 8.93286 0.921882 9.88528 1.5795 10.4493V10.4493C2.09599 10.8923 2.30694 11.5864 2.18005 12.2549C2.07237 12.8222 2.00004 13.401 2.00004 14C2.00004 14.599 2.07237 15.1778 2.18005 15.7451C2.30694 16.4136 2.09599 17.1077 1.5795 17.5507V17.5507C0.921882 18.1147 0.759229 19.0671 1.19238 19.8175L2.55283 22.1741C2.98856 22.9289 3.9008 23.2653 4.72226 22.9741V22.9741C5.36669 22.7457 6.07759 22.91 6.61324 23.3349C7.5169 24.0517 8.52235 24.633 9.60994 25.0663C10.2421 25.3181 10.7355 25.8498 10.8615 26.5185V26.5185C11.0234 27.3777 11.7739 28 12.6482 28H15.3519C16.2262 28 16.9767 27.3777 17.1386 26.5185V26.5185C17.2646 25.8498 17.758 25.3182 18.3899 25.0656C19.4757 24.6318 20.479 24.0491 21.3785 23.3353C21.9144 22.9101 22.6258 22.7458 23.2707 22.9744V22.9744C24.092 23.2655 25.0041 22.9297 25.4406 22.1756L26.8042 19.8201C27.239 19.0688 27.0756 18.1141 26.4156 17.5503V17.5503C25.8976 17.1077 25.6856 16.4128 25.8151 15.7438C25.9249 15.1769 26 14.5986 26 14C26 13.401 25.9277 12.8222 25.82 12.2549C25.6931 11.5864 25.9041 10.8923 26.4206 10.4493V10.4493C27.0782 9.88528 27.2409 8.93286 26.8077 8.18254L25.4477 5.82664C25.0114 5.07093 24.0989 4.73295 23.2756 5.02214V5.02214C22.6319 5.24825 21.923 5.08451 21.3876 4.66167C20.4856 3.94935 19.4822 3.37029 18.3969 2.94048C17.7613 2.68873 17.2643 2.15515 17.1381 1.4832V1.4832C16.9765 0.623124 16.2254 0 15.3503 0H12.6498ZM12.5778 3.18301C12.7048 2.49743 13.3028 2 14 2V2C14.6973 2 15.2953 2.49743 15.4222 3.18301L15.4737 3.461C15.5468 3.85556 15.8445 4.17054 16.2344 4.26563V4.26563C18.2188 4.71875 19.9688 5.75781 21.3125 7.19531V7.19531C21.5832 7.48494 21.9993 7.58736 22.3735 7.45641L22.6572 7.3571C23.3139 7.12725 24.0428 7.39921 24.3914 8.00137V8.00137C24.739 8.60162 24.6113 9.36683 24.0856 9.81925L23.8635 10.0104C23.5623 10.2696 23.444 10.6831 23.5625 11.0625V11.0625C23.8438 11.9844 24 12.9766 24 14C24 15.0234 23.8438 16.0078 23.5625 16.9375V16.9375C23.444 17.3169 23.5623 17.7304 23.8635 17.9896L24.0856 18.1808C24.6113 18.6332 24.7392 19.398 24.3917 19.9982V19.9982C24.0431 20.6004 23.3136 20.8708 22.6577 20.6387L22.3781 20.5398C22.0019 20.4067 21.5826 20.5109 21.3125 20.8047V20.8047C19.9688 22.2422 18.2188 23.2813 16.2344 23.7422V23.7422C15.8462 23.8274 15.5469 24.137 15.4748 24.5278L15.4204 24.8223C15.2945 25.5047 14.694 26 14 26V26C13.3061 26 12.7055 25.5047 12.5796 24.8223L12.5253 24.5278C12.4532 24.137 12.1538 23.8274 11.7656 23.7422V23.7422C9.78127 23.2813 8.03127 22.2422 6.68752 20.8047V20.8047C6.41228 20.5105 5.98893 20.4072 5.60911 20.5416L5.33705 20.6378C4.68012 20.8703 3.95088 20.6005 3.60343 19.9964V19.9964C3.25783 19.3956 3.38787 18.6339 3.91326 18.1817L4.13651 17.9896C4.43776 17.7304 4.55607 17.3169 4.43752 16.9375V16.9375C4.15627 16.0156 4.00002 15.0234 4.00002 14C4.00002 12.9766 4.15627 11.9844 4.43752 11.0625V11.0625C4.55607 10.6831 4.43776 10.2696 4.13651 10.0104L3.91326 9.81826C3.38787 9.36611 3.25853 8.60322 3.60413 8.00236V8.00236C3.95114 7.39907 4.67906 7.12687 5.33624 7.356L5.62633 7.45715C6.0007 7.58767 6.41683 7.485 6.68752 7.19531V7.19531C8.03127 5.75781 9.78127 4.71875 11.7656 4.26563V4.26563C12.1555 4.17054 12.4533 3.85557 12.5263 3.461L12.5778 3.18301ZM14 8.00001C10.6953 8.00001 8.00002 10.6953 8.00002 14C8.00002 17.3047 10.6953 20 14 20C17.3047 20 20 17.3047 20 14C20 10.6953 17.3047 8.00001 14 8.00001ZM14 10C16.2188 10 18 11.7813 18 14C18 16.2188 16.2188 18 14 18C11.7813 18 10 16.2188 10 14C10 11.7813 11.7813 10 14 10Z"/></svg>
                               <span>Booked</span> 
                            </a>
                        </li>
                         */}
					<li>
						<a
							className={activeMenuData == '/change-password' && 'active'}
							href="/change-password">
							<svg
								version="1.1"
								id="Layer_1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								width="25"
								height="28"
								viewBox="0 0 122.879 118.662">
								<g>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M43.101,54.363h4.138v-8.738c0-4.714,1.93-8.999,5.034-12.105v-0.004 c3.105-3.105,7.392-5.034,12.108-5.034c4.714,0,8.999,1.929,12.104,5.034l0.004,0.004c3.104,3.105,5.034,7.392,5.034,12.104v8.738 l3.297,0.001c0.734,0,1.335,0.601,1.335,1.335v28.203c0,0.734-0.602,1.335-1.336,1.335H43.101c-0.734,0-1.336-0.602-1.336-1.335 V55.698C41.765,54.964,42.366,54.363,43.101,54.363L43.101,54.363z M16.682,22.204c-1.781,2.207-3.426,4.551-5.061,7.457 c-5.987,10.645-8.523,22.731-7.49,34.543c1.01,11.537,5.432,22.827,13.375,32.271c2.853,3.392,5.914,6.382,9.132,8.968 c11.112,8.935,24.276,13.341,37.405,13.216c13.134-0.125,26.209-4.784,37.145-13.981c3.189-2.682,6.179-5.727,8.915-9.13 c6.396-7.957,10.512-17.29,12.071-27.138c1.532-9.672,0.595-19.829-3.069-29.655c-3.487-9.355-8.814-17.685-15.775-24.206 C96.695,8.333,88.593,3.755,79.196,1.483c-2.943-0.712-5.939-1.177-8.991-1.374c-3.062-0.197-6.193-0.131-9.401,0.224 c-2.011,0.222-3.459,2.03-3.238,4.041c0.222,2.01,2.03,3.459,4.04,3.237c2.783-0.308,5.495-0.366,8.141-0.195 c2.654,0.171,5.23,0.568,7.731,1.174c8.106,1.959,15.104,5.914,20.838,11.288c6.138,5.751,10.847,13.125,13.941,21.427 c3.212,8.613,4.035,17.505,2.696,25.959c-1.36,8.589-4.957,16.739-10.553,23.699c-2.469,3.071-5.121,5.78-7.912,8.127 c-9.591,8.067-21.031,12.153-32.502,12.263c-11.473,0.109-23.001-3.762-32.764-11.61c-2.895-2.328-5.621-4.983-8.129-7.966 c-6.917-8.224-10.771-18.092-11.655-28.202c-0.908-10.375,1.317-20.988,6.572-30.331c1.586-2.82,3.211-5.071,5.013-7.241 l0.533,14.696c0.071,2.018,1.765,3.596,3.782,3.524s3.596-1.765,3.524-3.782l-0.85-23.419c-0.071-2.019-1.765-3.596-3.782-3.525 c-0.126,0.005-0.25,0.016-0.372,0.032v-0.003L3.157,16.715c-2.001,0.277-3.399,2.125-3.122,4.126 c0.276,2.002,2.124,3.4,4.126,3.123L16.682,22.204L16.682,22.204L16.682,22.204z M53.899,54.363h20.963v-8.834 c0-2.883-1.18-5.504-3.077-7.403l-0.002,0.001c-1.899-1.899-4.521-3.08-7.402-3.08c-2.883,0-5.504,1.18-7.404,3.078 c-1.898,1.899-3.077,4.521-3.077,7.404V54.363L53.899,54.363L53.899,54.363z M64.465,69.795l2.116,9.764l-5.799,0.024l1.701-9.895 c-1.584-0.509-2.733-1.993-2.733-3.747c0-2.171,1.76-3.931,3.932-3.931c2.17,0,3.931,1.76,3.931,3.931 C67.612,67.845,66.261,69.433,64.465,69.795L64.465,69.795L64.465,69.795z"
									/>
								</g>
							</svg>
							<span>Change Password</span>
						</a>
					</li>
					<li>
						<a
							className={activeMenuData == '/profile' && 'active'}
							href="/profile">
							<svg
								width="28"
								height="28"
								viewBox="0 0 28 28"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M14 0.875C6.76705 0.875 0.875 6.76705 0.875 14C0.875 21.2329 6.76705 27.125 14 27.125C21.2329 27.125 27.125 21.2329 27.125 14C27.125 6.76705 21.2329 0.875 14 0.875ZM14 2.89423C20.1445 2.89423 25.1058 7.85554 25.1058 14C25.1058 16.7055 24.1435 19.1743 22.5502 21.0989C21.6825 18.6379 19.8053 16.6581 17.4075 15.6801C18.4092 14.7572 19.0481 13.44 19.0481 11.9808C19.0481 9.20432 16.7764 6.93269 14 6.93269C11.2236 6.93269 8.95193 9.20432 8.95193 11.9808C8.95193 13.44 9.59083 14.7572 10.5926 15.6801C8.19472 16.6581 6.32535 18.6379 5.45772 21.0989C3.85653 19.1743 2.89424 16.7055 2.89424 14C2.89424 7.85554 7.85555 2.89423 14 2.89423ZM14 8.95194C15.688 8.95194 17.0288 10.2928 17.0288 11.9808C17.0288 13.6687 15.688 15.0096 14 15.0096C12.3121 15.0096 10.9712 13.6687 10.9712 11.9808C10.9712 10.2928 12.3121 8.95194 14 8.95194ZM14 17.0288C17.4311 17.0288 20.247 19.4661 20.9017 22.7C19.0008 24.2066 16.6108 25.1057 14 25.1057C11.3892 25.1057 8.99925 24.2066 7.10623 22.7C7.75301 19.4661 10.5689 17.0288 14 17.0288Z"
								/>
							</svg>
							<span>profile</span>
						</a>
					</li>

					<li>
						<a
							className={activeMenuData == '/payments-history' && 'active'}
							href="/payments-history">
							<svg
								version="1.1"
								id="Layer_1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								width="28"
								height="28"
								viewBox="0 0 122.88 101.13">
								<g>
									<path
										class="st0"
										d="M86.64,45.01c3.23,0,6.1,1.56,7.89,3.96c1.79-2.41,4.66-3.96,7.89-3.96c5.43,0,9.83,4.4,9.83,9.83 s-4.4,9.83-9.83,9.83c-3.23,0-6.1-1.56-7.89-3.96c-1.79,2.41-4.66,3.96-7.89,3.96c-5.43,0-9.83-4.4-9.83-9.83 S81.21,45.01,86.64,45.01L86.64,45.01L86.64,45.01z M39.18,36.93c10.89,6.9,20.73,10.17,29.17,9.4c0.54,10.94-0.6,20.24-3.22,27.98 h51c0.78,0,1.49-0.32,2.01-0.84c0.52-0.52,0.84-1.23,0.84-2.01V33.99l0,0H3.91v37.47c0,0.78,0.32,1.49,0.84,2.01 c0.52,0.52,1.23,0.84,2.01,0.84h6.89c-2.58-7.74-3.82-17.15-3.53-28.44C20.03,46.4,29.76,44.25,39.18,36.93L39.18,36.93 L39.18,36.93z M63.63,78.22c-4.86,11.21-13.22,18.72-24.34,22.91C28.37,97.14,20.04,89.8,15.12,78.22H6.76 c-1.86,0-3.55-0.76-4.77-1.98C0.76,75.02,0,73.33,0,71.47V6.76C0,4.9,0.76,3.21,1.98,1.98C3.21,0.76,4.9,0,6.76,0l0,0h109.37 c1.86,0,3.55,0.76,4.77,1.98c1.22,1.22,1.98,2.92,1.98,4.77v64.7c0,1.86-0.76,3.55-1.98,4.77c-1.22,1.22-2.91,1.99-4.77,1.99H63.63 L63.63,78.22z M39.2,42.91c9.05,5.74,17.23,8.45,24.24,7.81c0.48,9.64-0.62,17.66-3.09,24.23l-0.07,0.18 c-0.08,0.2-0.15,0.4-0.23,0.59l-0.09,0.22c-0.07,0.18-0.15,0.36-0.22,0.54l-0.09,0.21c-0.08,0.18-0.16,0.36-0.24,0.54l-0.11,0.25 c-0.07,0.15-0.14,0.3-0.21,0.45l-0.15,0.3c-4.11,8.48-10.84,14.16-19.66,17.48c-8.68-3.17-15.39-8.71-19.54-17.48l-0.03-0.06 L19.7,78.1l-0.03-0.06c-0.07-0.16-0.14-0.31-0.21-0.47l-0.03-0.06l-0.03-0.06l-0.03-0.06l-0.03-0.06l-0.03-0.06 c-0.07-0.16-0.14-0.32-0.21-0.48l-0.03-0.06l-0.03-0.06l-0.03-0.06c-0.1-0.24-0.2-0.49-0.3-0.73l-0.02-0.06l-0.02-0.06 c-0.07-0.19-0.15-0.37-0.22-0.56l-0.02-0.06l-0.02-0.06l-0.02-0.06l-0.02-0.06c-0.07-0.19-0.14-0.38-0.21-0.57l-0.02-0.06 c-2.26-6.44-3.36-14.35-3.11-23.98C23.29,50.77,31.37,48.99,39.2,42.91L39.2,42.91L39.2,42.91z M3.91,14.56h115.06v-7.8 c0-0.78-0.32-1.49-0.84-2.01c-0.52-0.52-1.23-0.84-2.01-0.84H6.76c-0.78,0-1.49,0.32-2.01,0.84C4.23,5.27,3.91,5.98,3.91,6.76 V14.56L3.91,14.56L3.91,14.56z"
									/>
									<path
										class="st1"
										d="M24.62,67.34l5.17-0.07l0.39,0.1c1.04,0.6,2.03,1.29,2.95,2.07c0.66,0.56,1.3,1.17,1.9,1.84 c1.86-2.99,3.83-5.73,5.92-8.25c2.29-2.76,4.72-5.27,7.27-7.56l0.5-0.19h5.65l-1.14,1.26c-3.5,3.89-6.67,7.9-9.54,12.05 c-2.87,4.15-5.43,8.43-7.71,12.83l-0.71,1.37l-0.65-1.39c-1.2-2.58-2.64-4.95-4.36-7.07c-1.72-2.12-3.72-4-6.05-5.6L24.62,67.34 L24.62,67.34L24.62,67.34z"
									/>
								</g>
							</svg>
							<span>Payment</span>
						</a>
					</li>

					<li className="d-none">
						<a
							href="javascript:;"
							onClick={(event) => downloadDemoCertificate()}>
							<svg
								width="25"
								height="28"
								viewBox="0 0 365 511.41"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M312.22 319.17 365 442.58l-66.17-.77-54.38 44.12-47.7-116.25c13.79-3.35 27.44-10.32 41.22-21.13l1.66-1.22-.03-.04.9-.7-.04-.06c1.75-1.4 3.55-2.83 5.15-4.05 3.33.21 6.93.34 11.42.13 6.19-.28 12.83-1.26 20.17-3.62 6.46-2.08 12.45-4.63 17.95-7.67a92.904 92.904 0 0 0 15.92-11.07l-.04-.05 1.19-1.03zM176.94.02c6.61-.18 12.52.85 18.01 2.74 5.06 1.74 9.7 4.23 14.27 7.13 4.64 2.88 9.01 6.59 13.68 10.59 4.47 3.82 9.4 8.02 14.35 10.85l.32.19c2.04.78 7.25.99 12.7 1.18 18.99.7 39.48 1.46 54.86 24.29l.84 1.35c11.01 16.92 11.83 29.59 12.62 41.99l.04.87c.25 3.82.69 7.41 1.89 10.96 1.32 3.75 3.64 8.07 7.74 13.5 11.11 14.68 17.97 27.55 20.79 40.04 3.34 14.82 1.15 28.02-6.3 41.3-5.31 9.44-12.4 15.52-18.65 20.87-2.26 1.93-3.38 1.55-3.83 2.61l-.46 1.01c-1.07 3.17-1.14 7.07-1.19 11.04-.15 10.2-.33 20.77-7.49 34.9-4.49 8.84-10.36 16.31-17.53 22.41-7.04 6.06-15.27 10.57-24.61 13.58-9.57 3.08-17.24 2.54-24.49 2.02-2.77-.19-4.74-.67-5.07-.53-5.2 2.25-10.72 6.69-15.91 10.84l-1.2.9c-32.39 25.86-61.07 23.86-91.96-.9-5.18-4.15-10.71-8.58-15.92-10.76-.52-.23-4.25.39-5.06.45-7.26.52-14.93 1.06-24.49-2.02-9.35-3.01-17.57-7.52-24.61-13.5-7.13-6.06-12.99-13.56-17.53-22.49-7.18-14.14-7.34-24.71-7.49-34.91-.06-4.41-.14-8.72-1.57-12.04-.5-1.17-1.57-.61-3.91-2.61-6.24-5.34-13.35-11.41-18.66-20.87-7.45-13.28-9.63-26.48-6.29-41.3 2.81-12.5 9.67-25.36 20.78-40.04 4.1-5.43 6.43-9.75 7.72-13.51l.25-.7c1.03-3.31 1.43-6.68 1.65-10.25l.09-1.36c.81-12.58 1.77-25.45 13.42-42.77 15.37-22.9 35.87-23.67 54.87-24.37 5.79-.21 11.31-.43 13.04-1.33 4.94-2.87 9.86-7.07 14.35-10.91l1.22-.97c4.21-3.57 8.18-6.91 12.37-9.56 4.46-2.89 9.11-5.38 14.33-7.17C164.41.87 170.29-.16 176.94.02zm.01 17.56c8.32-.36 14.88 2.54 21.5 6.75 8.4 5.33 17.86 15.85 29.53 22.53 16.43 9.38 46.85-3.57 62.43 19.58 9.09 13.49 9.51 24.08 10.19 34.53.73 11.28 2.71 21.65 14.25 36.92 19.11 25.27 23.09 42.09 13.25 59.62-6.72 11.95-20.85 18.59-24.12 26.16-6.96 16.1.74 28.24-8.79 47.01-6.61 13.03-16.82 21.61-30.42 25.99-11.46 3.69-22.96-1.65-32.14 2.21-16.13 6.77-28.03 22.53-40.86 26.51-4.95 1.53-9.89 2.29-14.82 2.26-4.93.03-9.87-.73-14.82-2.26-12.84-3.98-24.73-19.74-40.86-26.51-9.18-3.86-20.68 1.48-32.15-2.21-13.59-4.38-23.8-12.96-30.41-25.99-9.53-18.77-1.83-30.91-8.79-47.01-3.27-7.57-17.41-14.21-24.12-26.16-9.85-17.53-5.86-34.35 13.24-59.62 11.54-15.27 13.52-25.64 14.25-36.92.68-10.45 1.11-21.04 10.19-34.53 15.58-23.15 46.01-10.2 62.43-19.58 11.68-6.68 21.13-17.2 29.54-22.53 6.62-4.21 13.18-7.11 21.5-6.75zm1.92 110.29 12.5 29.27 31.71 2.84a2.53 2.53 0 0 1 2.31 2.75 2.55 2.55 0 0 1-.86 1.7l-23.98 20.94 7.09 31.05a2.543 2.543 0 0 1-3.87 2.7l-27.25-16.29-27.33 16.34c-1.21.72-2.77.33-3.49-.88a2.53 2.53 0 0 1-.3-1.87l7.1-31.05-23.99-20.94a2.538 2.538 0 0 1-.24-3.59c.47-.54 1.12-.83 1.78-.87l31.62-2.83 12.51-29.29c.55-1.3 2.04-1.9 3.34-1.35.64.27 1.1.78 1.35 1.37zm-2.35-52.98c55.04 0 99.67 44.63 99.67 99.67 0 55.05-44.63 99.67-99.67 99.67-55.05 0-99.67-44.62-99.67-99.67 0-55.04 44.62-99.67 99.67-99.67zm0 16.83c45.75 0 82.84 37.09 82.84 82.84 0 45.76-37.09 82.84-82.84 82.84-45.76 0-82.84-37.08-82.84-82.84 0-45.75 37.08-82.84 82.84-82.84zm-.33 280.31-55.64 139.38-54.38-44.11-66.17.76 57.72-137.29 1.05.59c5.5 3.01 11.49 5.57 17.91 7.63 7.33 2.36 13.97 3.34 20.16 3.62 4.44.21 8.02.08 11.33-.12 1.63 1.23 3.51 2.73 5.31 4.18l.04.03c20.08 16.08 40.24 24.8 61.63 25.32l1.04.01z"
								/>
							</svg>
							<span>Certificate</span>
						</a>
					</li>

					{/* <li>
						<a
							className={activeMenuData == '/message' && 'active'}
							href="/message">
							<svg
								version="1.1"
								id="Layer_1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								width="28"
								height="28"
								viewBox="0 0 122.88 101.13">
								<g>
									<path
										class="st0"
										d="M86.64,45.01c3.23,0,6.1,1.56,7.89,3.96c1.79-2.41,4.66-3.96,7.89-3.96c5.43,0,9.83,4.4,9.83,9.83 s-4.4,9.83-9.83,9.83c-3.23,0-6.1-1.56-7.89-3.96c-1.79,2.41-4.66,3.96-7.89,3.96c-5.43,0-9.83-4.4-9.83-9.83 S81.21,45.01,86.64,45.01L86.64,45.01L86.64,45.01z M39.18,36.93c10.89,6.9,20.73,10.17,29.17,9.4c0.54,10.94-0.6,20.24-3.22,27.98 h51c0.78,0,1.49-0.32,2.01-0.84c0.52-0.52,0.84-1.23,0.84-2.01V33.99l0,0H3.91v37.47c0,0.78,0.32,1.49,0.84,2.01 c0.52,0.52,1.23,0.84,2.01,0.84h6.89c-2.58-7.74-3.82-17.15-3.53-28.44C20.03,46.4,29.76,44.25,39.18,36.93L39.18,36.93 L39.18,36.93z M63.63,78.22c-4.86,11.21-13.22,18.72-24.34,22.91C28.37,97.14,20.04,89.8,15.12,78.22H6.76 c-1.86,0-3.55-0.76-4.77-1.98C0.76,75.02,0,73.33,0,71.47V6.76C0,4.9,0.76,3.21,1.98,1.98C3.21,0.76,4.9,0,6.76,0l0,0h109.37 c1.86,0,3.55,0.76,4.77,1.98c1.22,1.22,1.98,2.92,1.98,4.77v64.7c0,1.86-0.76,3.55-1.98,4.77c-1.22,1.22-2.91,1.99-4.77,1.99H63.63 L63.63,78.22z M39.2,42.91c9.05,5.74,17.23,8.45,24.24,7.81c0.48,9.64-0.62,17.66-3.09,24.23l-0.07,0.18 c-0.08,0.2-0.15,0.4-0.23,0.59l-0.09,0.22c-0.07,0.18-0.15,0.36-0.22,0.54l-0.09,0.21c-0.08,0.18-0.16,0.36-0.24,0.54l-0.11,0.25 c-0.07,0.15-0.14,0.3-0.21,0.45l-0.15,0.3c-4.11,8.48-10.84,14.16-19.66,17.48c-8.68-3.17-15.39-8.71-19.54-17.48l-0.03-0.06 L19.7,78.1l-0.03-0.06c-0.07-0.16-0.14-0.31-0.21-0.47l-0.03-0.06l-0.03-0.06l-0.03-0.06l-0.03-0.06l-0.03-0.06 c-0.07-0.16-0.14-0.32-0.21-0.48l-0.03-0.06l-0.03-0.06l-0.03-0.06c-0.1-0.24-0.2-0.49-0.3-0.73l-0.02-0.06l-0.02-0.06 c-0.07-0.19-0.15-0.37-0.22-0.56l-0.02-0.06l-0.02-0.06l-0.02-0.06l-0.02-0.06c-0.07-0.19-0.14-0.38-0.21-0.57l-0.02-0.06 c-2.26-6.44-3.36-14.35-3.11-23.98C23.29,50.77,31.37,48.99,39.2,42.91L39.2,42.91L39.2,42.91z M3.91,14.56h115.06v-7.8 c0-0.78-0.32-1.49-0.84-2.01c-0.52-0.52-1.23-0.84-2.01-0.84H6.76c-0.78,0-1.49,0.32-2.01,0.84C4.23,5.27,3.91,5.98,3.91,6.76 V14.56L3.91,14.56L3.91,14.56z"
									/>
									<path
										class="st1"
										d="M24.62,67.34l5.17-0.07l0.39,0.1c1.04,0.6,2.03,1.29,2.95,2.07c0.66,0.56,1.3,1.17,1.9,1.84 c1.86-2.99,3.83-5.73,5.92-8.25c2.29-2.76,4.72-5.27,7.27-7.56l0.5-0.19h5.65l-1.14,1.26c-3.5,3.89-6.67,7.9-9.54,12.05 c-2.87,4.15-5.43,8.43-7.71,12.83l-0.71,1.37l-0.65-1.39c-1.2-2.58-2.64-4.95-4.36-7.07c-1.72-2.12-3.72-4-6.05-5.6L24.62,67.34 L24.62,67.34L24.62,67.34z"
									/>
								</g>
							</svg>
							<span>Chat</span>
						</a>
					</li> */}
				</ul>
			</div>

			<p
				onClick={(e) => {
					logout();
				}}
				class="take_logout">
				<a href="#">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3.25 23.25C1.875 23.25 0.75 22.125 0.75 20.75L0.75 10.75H3.25L3.25 20.75H20.75V10.75H23.25V20.75C23.25 22.125 22.125 23.25 20.75 23.25H3.25ZM10.75 5.53L7.58 8.7L5.8125 6.9325L12 0.745003L18.1875 6.9325L16.42 8.7L13.25 5.53V13.7625H10.75V5.53Z"
							fill="#17204F"
						/>
					</svg>{' '}
					<span>logout</span>{' '}
				</a>
			</p>
		</div>
	);
};
export default Sidebar_inner;
